/* Bean Shipper · Office Coffee landing (/products/big-bag and /pages/office-coffee). Section: page__bs-office.
   2 Nov 2026: [data-bso-once] = one-time 1kg add without a selling plan (see the click handler).
   Everything here is progressive: without it the form adds the default subscription and the
   chapters read as a plain flow. Motion is transform and clip-path only; nothing animates opacity.
   The theme's ajax cart owns the submit (form[data-bs-add]) and restores each [data-bs-pdp-add]
   button's HTML after an add, so labels are always re-queried, never cached. */
(function () {
  'use strict';

  function qsa(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }

  function rm(cents) {
    var c = Math.round(cents), i = Math.floor(c / 100), f = c % 100;
    var s = String(i).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'RM' + s + (f ? '.' + (f < 10 ? '0' : '') + f : '');
  }

  function init(root) {
    if (root.__bso) return;
    root.__bso = true;

    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var V = [];
    (root.getAttribute('data-vmap') || '').split('||').forEach(function (e) {
      var a = e.split('~');
      if (a.length < 5) return;
      V.push({ coffee: a[0], size: a[1], id: a[2], price: parseInt(a[3], 10) || 0, avail: a[4] === 'true' });
    });
    var sizes = (root.getAttribute('data-sizes') || '').split('||').filter(Boolean);
    var plans = {}, weeksList = [];
    (root.getAttribute('data-plans') || '').split('||').forEach(function (e) {
      var a = e.split('~');
      if (a.length !== 2) return;
      plans[a[0]] = a[1];
      weeksList.push(parseInt(a[0], 10));
    });
    weeksList.sort(function (x, y) { return x - y; });

    var S = {
      coffee: root.getAttribute('data-def-coffee') || '',
      size: root.getAttribute('data-def-size') || sizes[0] || '',
      weeks: parseInt(root.getAttribute('data-def-weeks'), 10) || weeksList[0] || 2,
      people: parseInt(root.getAttribute('data-calc-people'), 10) || 10,
      cups: 2
    };

    var idIn = root.querySelector('[data-bso-id]');
    var planIn = root.querySelector('[data-bso-plan]');
    var cfg = root.querySelector('[data-bso-cfg]');
    var fin = root.querySelector('[data-bso-final]');
    var sizesGo = root.querySelector('.bso-sizes__go');
    var dock = root.querySelector('[data-bso-dock]');

    function kgOf(sv) { var m = /([\d.]+)\s*kg/i.exec(sv || ''); return m ? parseFloat(m[1]) : 0; }
    function nameOf(sv) { return String(sv || '').split('(')[0].trim(); }
    function saveOf(sv) { var m = /save\s*(\d+)\s*%/i.exec(sv || ''); return m ? parseInt(m[1], 10) : 0; }
    function cupsOf(sv) { return Math.floor(kgOf(sv) * 1000 / 15); }
    function find(coffee, size) {
      for (var i = 0; i < V.length; i++) if (V[i].coffee === coffee && V[i].size === size) return V[i];
      return null;
    }
    function freqLabel(w) { return w === 1 ? 'every week' : 'every ' + w + ' weeks'; }
    var maxSave = sizes.reduce(function (m, s) { return Math.max(m, saveOf(s)); }, 0);
    var hdr = function () { return parseInt(getComputedStyle(root).getPropertyValue('--hdr'), 10) || 0; };

    /* ---------- configurator ---------- */
    function values() {
      var v = find(S.coffee, S.size), o = {};
      o.coffee = S.coffee;
      o.size = nameOf(S.size);
      o.freq = freqLabel(S.weeks);
      sizes.forEach(function (sv, i) {
        var x = find(S.coffee, sv), kg = kgOf(sv), cu = cupsOf(sv);
        o['c' + i] = String(cu);
        if (!x || !kg || !cu) return;
        o['t' + i] = rm(x.price);
        o['k' + i] = rm(x.price / kg);
        o['pc' + i] = rm(x.price / cu);
      });
      if (v) {
        var kg = kgOf(S.size), cu = cupsOf(S.size);
        o.total = rm(v.price);
        o.perkg = rm(v.price / kg);
        o.percup = rm(v.price / cu);
        o.cups = String(cu);
      }
      var sp = saveOf(S.size);
      o.save = sp ? 'Save ' + sp + '% vs ' + nameOf(sizes[0]) : 'Base price · save up to ' + maxSave + '% on bigger bags';
      return { o: o, v: v };
    }

    function press(sel, attr, val) {
      qsa(sel, root).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute(attr) === String(val))); });
    }

    function render() {
      var r = values(), v = r.v;
      if (v && idIn) idIn.value = v.id;
      if (planIn) { planIn.disabled = false; planIn.value = plans[S.weeks] || ''; }
      press('[data-bso-coffee]', 'data-bso-coffee', S.coffee);
      press('[data-bso-size]', 'data-bso-size', S.size);
      press('[data-bso-weeks]', 'data-bso-weeks', S.weeks);
      qsa('[data-bso-size]', root).forEach(function (b) {
        var x = find(S.coffee, b.getAttribute('data-bso-size'));
        b.disabled = !(x && x.avail);
      });
      qsa('[data-bso-v]', root).forEach(function (el) {
        var k = el.getAttribute('data-bso-v');
        if (r.o[k] != null && el.textContent !== r.o[k]) el.textContent = r.o[k];
      });
      var ok = !!(v && v.avail && planIn && planIn.value);
      qsa('[data-bs-pdp-add]', root).forEach(function (b) { b.disabled = !ok; });
      root.setAttribute('data-avail', ok ? 'true' : 'false');
      calc();
    }

    /* ---------- team calculator ---------- */
    function rec(kgWeek, coffee) {
      var best = null;
      sizes.forEach(function (sv) {
        var x = find(coffee, sv), kg = kgOf(sv);
        if (!x || !x.avail || !kg) return;
        weeksList.forEach(function (w) {
          if (kg / w + 1e-9 < kgWeek) return;
          var perWeek = x.price / w;
          if (!best || perWeek < best.perWeek - 0.01) best = { sv: sv, w: w, price: x.price, perWeek: perWeek };
        });
      });
      return best;
    }
    function put(sel, txt) {
      var el = root.querySelector(sel);
      if (el && el.textContent !== txt) el.textContent = txt;
      return el;
    }
    var lastRec = null;
    function calc() {
      if (!root.querySelector('[data-bso-calc]')) return;
      var kgw = S.people * S.cups * 15 * 5 / 1000;
      put('[data-bso-calc-people]', String(S.people));
      put('[data-bso-calc-kg]', String(Math.round(kgw * 10) / 10));
      qsa('[data-bso-cups]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-bso-cups') === S.cups)); });
      var b = rec(kgw, S.coffee);
      lastRec = b;
      if (b) {
        var key = b.sv + '|' + b.w;
        var sz = put('[data-bso-calc-size]', nameOf(b.sv));
        put('[data-bso-calc-freq]', freqLabel(b.w));
        put('[data-bso-calc-cost]', rm(b.price));
        put('[data-bso-calc-pc]', rm(b.price / cupsOf(b.sv)));
        put('[data-bso-calc-lbl]', 'Use ' + nameOf(b.sv) + ' ' + freqLabel(b.w));
        if (sz && sz.getAttribute('data-key') !== key) {
          if (sz.getAttribute('data-key') && !reduce) { sz.removeAttribute('data-bso-bump'); void sz.offsetWidth; sz.setAttribute('data-bso-bump', 'true'); }
          sz.setAttribute('data-key', key);
        }
      } else {
        put('[data-bso-calc-size]', nameOf(sizes[sizes.length - 1]) + '+');
        put('[data-bso-calc-freq]', 'talk to us');
        put('[data-bso-calc-lbl]', 'Talk to us');
      }
    }

    function scrollToEl(el, extra) {
      if (!el) return;
      window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - hdr() - (extra || 0), behavior: reduce ? 'auto' : 'smooth' });
    }

    /* ---------- chapters ---------- */
    var chs = qsa('[data-bso-ch]', root).map(function (el) {
      return {
        el: el, n: +el.getAttribute('data-n') || 1, base: +el.getAttribute('data-base') || 0,
        stage: el.querySelector('.bso-ch__stage'), prog: el.querySelector('[data-bso-prog]'), qn: el.querySelector('[data-bso-qn]'),
        qs: qsa('[data-bso-q]', el), lis: qsa('[data-bso-li]', el), a: 0
      };
    });
    var mqSticky = window.matchMedia ? window.matchMedia('(min-width: 1024px) and (min-height: 700px)') : null;
    var sticky = false;
    function setActive(c, a) {
      c.a = a;
      c.qs.forEach(function (q) {
        var i = +q.getAttribute('data-bso-q');
        q.setAttribute('data-on', String(i === a));
        q.setAttribute('data-past', String(i < a));
      });
      c.lis.forEach(function (li) { li.setAttribute('data-on', String(+li.getAttribute('data-bso-li') === a)); });
      if (c.qn) c.qn.textContent = String(c.base + a + 1);
    }
    function setMode() {
      var s = !reduce && !!(mqSticky && mqSticky.matches);
      if (s === sticky && root.getAttribute('data-mode')) return;
      sticky = s;
      root.setAttribute('data-mode', s ? 'sticky' : 'flow');
      chs.forEach(function (c) {
        c.el.setAttribute('data-sticky', String(s));
        if (!s) setActive(c, 0);
      });
      tick();
    }
    function tickChapters() {
      if (!sticky) return;
      var vh = window.innerHeight, h = hdr();
      chs.forEach(function (c) {
        var r = c.el.getBoundingClientRect();
        if (r.bottom < -vh || r.top > vh * 2) return;
        var range = Math.max(1, c.el.offsetHeight - c.stage.offsetHeight);
        var p = Math.min(1, Math.max(0, (h - r.top) / range));
        var a = Math.min(c.n - 1, Math.floor(p * c.n));
        if (c.prog) c.prog.style.transform = 'scaleX(' + p.toFixed(4) + ')';
        if (a !== c.a) setActive(c, a);
      });
    }
    function goTo(ci, qi) {
      var c = chs[ci];
      if (!c) return;
      if (sticky) {
        var top = c.el.getBoundingClientRect().top + window.pageYOffset - hdr();
        var range = Math.max(1, c.el.offsetHeight - c.stage.offsetHeight);
        window.scrollTo({ top: top + (qi + 0.5) / c.n * range, behavior: reduce ? 'auto' : 'smooth' });
      } else {
        scrollToEl(root.querySelector('#bso-q-' + ci + '-' + qi), 16);
      }
    }

    /* ---------- dock, parallax ---------- */
    var dockOn = false;
    function tickDock() {
      if (!dock || !cfg) return;
      var vh = window.innerHeight, sg = sizesGo ? sizesGo.getBoundingClientRect() : null;
      // Off while the order box, the sizes Start button or the closing section is on screen.
      var on = cfg.getBoundingClientRect().bottom < hdr() && (!fin || fin.getBoundingClientRect().top > vh - 40) && !(sg && sg.top < vh && sg.bottom > hdr());
      if (on === dockOn) return;
      dockOn = on;
      dock.setAttribute('data-on', String(on));
      dock.setAttribute('aria-hidden', String(!on));
      if (on) dock.removeAttribute('inert'); else dock.setAttribute('inert', '');
    }
    var par = root.querySelector('[data-bso-par]');
    function tickPar() {
      if (!par || reduce) return;
      if (window.innerWidth < 1024) { if (par.style.transform) par.style.transform = ''; return; }
      var y = window.pageYOffset;
      if (y < window.innerHeight * 2) par.style.transform = 'translate3d(0,' + (y * -0.08).toFixed(1) + 'px,0)';
    }

    var raf = 0;
    function tick() { tickChapters(); tickDock(); tickPar(); }
    function onScroll() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; tick(); }); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { setMode(); onScroll(); });
    if (mqSticky) {
      if (mqSticky.addEventListener) mqSticky.addEventListener('change', setMode);
      else if (mqSticky.addListener) mqSticky.addListener(setMode);
    }

    /* ---------- clicks ---------- */
    root.addEventListener('click', function (e) {
      var once = e.target.closest('[data-bso-once]');
      if (once && root.contains(once)) {
        // One-time 1kg of the chosen coffee (2 Nov 2026): swap in the 1kg variant and drop the selling plan
        // for this one submit. The submit handler's render() restores the plan and the chosen size afterwards.
        var x1 = find(S.coffee, sizes[0]);
        if (x1 && idIn) idIn.value = x1.id;
        if (planIn) planIn.disabled = true;
        return;
      }
      var t = e.target.closest('[data-bso-coffee],[data-bso-size],[data-bso-weeks],[data-bso-goto],[data-bso-calc],[data-bso-cups],[data-bso-calc-apply]');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-bso-coffee')) S.coffee = t.getAttribute('data-bso-coffee');
      else if (t.hasAttribute('data-bso-size')) { if (t.disabled) return; S.size = t.getAttribute('data-bso-size'); }
      else if (t.hasAttribute('data-bso-weeks')) S.weeks = parseInt(t.getAttribute('data-bso-weeks'), 10);
      else if (t.hasAttribute('data-bso-goto')) {
        var g = t.getAttribute('data-bso-goto').split('-');
        goTo(+g[0], +g[1]);
        return;
      } else if (t.hasAttribute('data-bso-calc')) {
        S.people = Math.max(2, Math.min(60, S.people + (t.getAttribute('data-bso-calc') === '+' ? 1 : -1)));
      } else if (t.hasAttribute('data-bso-cups')) S.cups = parseInt(t.getAttribute('data-bso-cups'), 10) || 1;
      else if (t.hasAttribute('data-bso-calc-apply')) {
        if (!lastRec) { window.location.href = '/pages/contact-us'; return; }
        S.size = lastRec.sv;
        S.weeks = lastRec.w;
        render();
        scrollToEl(cfg, 16);
        return;
      }
      render();
    });
    // The ajax cart restores each button's HTML as it was at submit time; re-render afterwards.
    root.addEventListener('submit', function () { setTimeout(render, 2500); setTimeout(render, 6000); });

    /* ---------- rotating word ---------- */
    var rot = root.querySelector('[data-bso-rot]');
    var heroOn = true;
    if (rot && !reduce) {
      var words = (rot.getAttribute('data-words') || '').split('|').map(function (w) { return w.trim(); }).filter(Boolean);
      var wEl = rot.querySelector('[data-bso-rot-w]'), wi = 0;
      if (wEl && words.length > 1) {
        setInterval(function () {
          if (document.hidden || !heroOn) return;
          wi = (wi + 1) % words.length;
          wEl.textContent = words[wi];
          wEl.classList.remove('is-in');
          void wEl.offsetWidth;
          wEl.classList.add('is-in');
        }, 2800);
      }
    }

    /* ---------- reveals and loop pausing ---------- */
    var rv = qsa('[data-bso-rv],[data-bso-rvq],[data-bso-stagger]', root);
    var loops = qsa('[data-bso-loop]', root);
    var hero = root.querySelector('[data-bso-hero]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting) { en.target.setAttribute('data-in', 'true'); io.unobserve(en.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      rv.forEach(function (el) { io.observe(el); });
      var lo = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          en.target.setAttribute('data-run', String(en.isIntersecting));
          if (en.target === hero) heroOn = en.isIntersecting;
        });
      }, { threshold: 0 });
      loops.forEach(function (el) { lo.observe(el); });
    } else {
      rv.forEach(function (el) { el.setAttribute('data-in', 'true'); });
    }
    root.setAttribute('data-js', 'true');

    window.addEventListener('pageshow', function () { render(); tick(); });
    render();
    setMode();
    tick();
  }

  function boot() { qsa('[data-bso]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
